<script lang="ts">
	import { userSeasonStats, userPolyPoints } from '$lib/tradingSeason/store';
	import AnimatedBorder from '$lib/tradingSeason/shared/AnimatedBorder.svelte';
	import { convertToInternationalCurrencySystem, getNumBackInUnits } from '$lib/util/util';
	import { userMarginBalanceForTrade } from '../userInteract/store';

	export let openMenu: () => void;
</script>

<AnimatedBorder>
	<button
		class="bg-fx-gradient-6 p-px pr-2 rounded-md squircle-lg flex gap-[6px] justify-center items-center overflow-hidden"
		on:click={openMenu}
	>
		<div
			class="px-2 py-[2.5px] rounded-md border-fx-grey-400 border border-solid bg-fx-grey-900 flex justify-center items-center gap-1"
		>
			<span class="text-gradients-accent-shade-3 text-sm">
				<!-- Lvl {$userSeasonStats?.level || 0} commented this out to show hardcoded data for the teaser-->
				Lvl 69
			</span>
			<div class="w-[1px] h-7 bg-fx-gradient-divider" />
			<div class="flex gap-0.5 justify-center items-center">
				<p class="text-sm font-semibold text-gradients-accent-shade-6">
					<!-- {$userPolyPoints
						? convertToInternationalCurrencySystem($userPolyPoints?.totalPolyPoints, 1)
						: 0} commented this out to show hardcoded data for the teaser-->
					420
				</p>
				<img
					src="trading-season/points.webp"
					alt="XP"
					loading="lazy"
					class="w-[17px] h-[17px] -mt-0.5"
				/>
			</div>
		</div>
		<p class="text-sm font-medium text-fx-blue">
			${getNumBackInUnits($userMarginBalanceForTrade || '0', 18, 2)}
		</p>
	</button>
</AnimatedBorder>
